import { Link } from "react-router";
import { RouteFactory } from "@app/routePaths";
import bTWhiteLogo from "@assets/bt-icon-white.svg";
import Container from "@components/Container/Container";
import SubscribeTrigger from "@components/Header/SubscribeTrigger/SubscribeTrigger";
import { formatDateToReadable } from "@events-awards/utils/helpers";
import { useUserInfo } from "@features/mySph/hooks/useUserInfo";
import PosthogFeature from "@features/posthog/PosthogFeature";
import MyAccountHeader from "@routes/MyAccount/components/MyAccountHeader/MyAccountHeader";
import MyAccountPopoverLogin from "@routes/MyAccount/components/MyAccountPopoverLogin/MyAccountPopoverLogin";
import { cn } from "@util/helpers";

/**
 * Component to render Event Awards Header
 */
const EventsAwardsHeader = (): React.ReactElement => {
  const { displayName, isSubscriber } = useUserInfo();

  return (
    <header
      data-testid="events-awards-header-component"
      className="mb-4 w-full flex-none bg-gray-850"
    >
      <Container rootClassName="flex flex-row justify-between items-center py-2">
        <Link to={RouteFactory.home} reloadDocument>
          <img
            src={bTWhiteLogo}
            alt="Business Times logo"
            width={200}
            height={20}
          />
        </Link>

        <p className="mb-0 hidden font-poppins text-4xs uppercase text-white lg:block">
          {formatDateToReadable()}
        </p>

        <div className={"items-center sm:flex sm:flex-col md:flex-row"}>
          {!isSubscriber ? (
            <div className="flex flex-col items-end">
              <PosthogFeature flagName="feature_enable_user_login">
                <SubscribeTrigger rootClassName="text-base" />
              </PosthogFeature>
            </div>
          ) : null}

          <div
            className={cn("flex justify-end", {
              "md:ml-3": !isSubscriber,
              "mr-4 mt-1 md:mr-0": displayName && !isSubscriber,
            })}
          >
            {displayName ? (
              <MyAccountHeader textClassName="text-white hover:text-gray-250 lg:hover:bg-gray-850" />
            ) : (
              <PosthogFeature flagName="feature_enable_user_login">
                <MyAccountPopoverLogin
                  isSiaPage
                  textClassName="w-[160px] pr-0 md:w-full pr-3 text-left whitespace-normal break-words"
                />
              </PosthogFeature>
            )}
          </div>
        </div>
      </Container>
    </header>
  );
};

export default EventsAwardsHeader;
